import { Navigate, Routes, Route, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
// layouts
import DashboardLayout from './layouts/dashboard';
// Components
import Login from './pages/Login';
import Register from './pages/Register';
import ForgetPassword from './pages/ForgetPassword';
import DashboardApp from './pages/DashboardApp';
import NotFound from './pages/Page404';
import { AuthProvider } from './context/AuthContext';
import Students from './pages/Students';
import TeacherClasses from './pages/Teacher/Class/Teacher.Classes';
import StudentClasses from './pages/Student/Class/Student.Classes';
import StudentProfile from './pages/profile/StudentProfile';
import AdminProfile from './pages/profile/AdminProfile';
import TeacherInsights from './pages/Teacher/Insights/Teacher.Insights';
import Promote from './pages/Teacher/Teacher.Promote';
import StudentInsights from './pages/Student/Insights/Student.Insights';
import PickUserType from './pages/PickUserType';
import Teachers from './pages/Teachers';
import EnrollPage from './pages/Enroll';
import ClassDetails from './components/common/ClassDetails';
import InstituteProfile from './pages/profile/InstituteProfile';
import NewFullPageCalender from './pages/NewFullPageCalender';
import StudentOffers from './pages/Student/Offers/Student.Offers';
import StudentDiscover from './pages/Student/Discover/Student.Discover';
import TeacherProfile from './pages/profile/TeacherProfile';
import OnlineTest from './pages/Student/Class/Test/Student.OnlineTest';
import TestResult from './components/common/TestResult';

// ----------------------------------------------------------------------
function StudentRoutes() {
  const currentUser = useSelector((state) => state.auth.currentUser);
  const selectedOrg = useSelector((state) => state.org.selectedOrg);
  return (
    <Routes>
      <Route
        path="/"
        element={currentUser ? <Navigate to="dashboard/app" /> : <Navigate to="login" />}
      />
      <Route
        path="dashboard/app"
        element={
          <DashboardLayout>
            <StudentInsights />
          </DashboardLayout>
        }
      />
      <Route
        path="dashboard/classes"
        element={
          <DashboardLayout>
            <StudentClasses />
          </DashboardLayout>
        }
      />
      <Route
        path="dashboard/classes/:id"
        element={
          <DashboardLayout>
            <ClassDetails />
          </DashboardLayout>
        }
      />
      <Route
        path="dashboard/account"
        element={
          <DashboardLayout>
            <StudentProfile />
          </DashboardLayout>
        }
      />
      {(selectedOrg?.id ?? selectedOrg?._id) && (
        <Route
          path="dashboard/calender"
          element={
            <DashboardLayout>
              <NewFullPageCalender isStudentCalendar />
            </DashboardLayout>
          }
        />
      )}
      <Route
        path="enroll/:id"
        element={
          <DashboardLayout>
            <EnrollPage />
          </DashboardLayout>
        }
      />
      <Route
        path="dashboard/offers"
        element={
          <DashboardLayout>
            <StudentOffers />
          </DashboardLayout>
        }
      />
      <Route
        path="dashboard/discover"
        element={
          <DashboardLayout>
            <StudentDiscover />
          </DashboardLayout>
        }
      />
      <Route path="dashboard/in-app/test/:id" element={<OnlineTest />} />
      <Route path="dashboard/test/:testId/result/:id" element={<TestResult />} />
      <Route
        path="*"
        element={
          <DashboardLayout>
            <NotFound />
          </DashboardLayout>
        }
      />
    </Routes>
  );
}

function TeacherRoutes() {
  const currentUser = useSelector((state) => state.auth.currentUser);
  return (
    <Routes>
      <Route
        path="/"
        element={currentUser ? <Navigate to="dashboard/app" /> : <Navigate to="login" />}
      />
      <Route
        path="dashboard/app"
        element={
          <DashboardLayout>
            <TeacherInsights />
          </DashboardLayout>
        }
      />
      <Route
        path="dashboard/classes"
        element={
          <DashboardLayout>
            <TeacherClasses />
          </DashboardLayout>
        }
      />
      <Route
        path="dashboard/classes/:id"
        element={
          <DashboardLayout>
            <ClassDetails />
          </DashboardLayout>
        }
      />
      <Route
        path="dashboard/account"
        element={
          <DashboardLayout>
            <TeacherProfile />
          </DashboardLayout>
        }
      />
      <Route
        path="dashboard/calender"
        element={
          <DashboardLayout>
            <NewFullPageCalender />
          </DashboardLayout>
        }
      />
      <Route
        path="dashboard/promote"
        element={
          <DashboardLayout>
            <Promote />
          </DashboardLayout>
        }
      />
      <Route
        path="dashboard/students"
        element={
          <DashboardLayout>
            <Students />
          </DashboardLayout>
        }
      />
      <Route
        path="enroll/:id"
        element={
          <DashboardLayout>
            <EnrollPage />
          </DashboardLayout>
        }
      />
      <Route path="dashboard/test/:testId/result/:id" element={<TestResult />} />
      <Route
        path="*"
        element={
          <DashboardLayout>
            <NotFound />
          </DashboardLayout>
        }
      />
    </Routes>
  );
}

function AdminRoutes() {
  const currentUser = useSelector((state) => state.auth.currentUser);
  const selectedOrg = useSelector((state) => state.org.selectedOrg);
  return (
    <Routes>
      <Route
        path="/"
        element={currentUser ? <Navigate to="dashboard/app" /> : <Navigate to="login" />}
      />
      <Route
        path="dashboard/app"
        element={
          <DashboardLayout>
            <DashboardApp />
          </DashboardLayout>
        }
      />
      <Route
        path="dashboard/classes"
        element={
          <DashboardLayout>
            <TeacherClasses />
          </DashboardLayout>
        }
      />
      <Route
        path="dashboard/classes/:id"
        element={
          <DashboardLayout>
            <ClassDetails />
          </DashboardLayout>
        }
      />
      <Route
        path="dashboard/account"
        element={
          <DashboardLayout>
            <AdminProfile />
          </DashboardLayout>
        }
      />
      <Route
        path="dashboard/calender"
        element={
          <DashboardLayout>
            <NewFullPageCalender isStudentCalendar={selectedOrg.role !== 'admin'} />
          </DashboardLayout>
        }
      />
      <Route
        path="dashboard/students"
        element={
          <DashboardLayout>
            <Students />
          </DashboardLayout>
        }
      />
      <Route
        path="/dashboard/teacher"
        element={
          <DashboardLayout>
            <Teachers />
          </DashboardLayout>
        }
      />
      <Route
        path="enroll/:id"
        element={
          <DashboardLayout>
            <EnrollPage />
          </DashboardLayout>
        }
      />
      <Route path="dashboard/test/:testId/result/:id" element={<TestResult />} />
      <Route
        path="dashboard/institute"
        element={
          <DashboardLayout>
            <InstituteProfile />
          </DashboardLayout>
        }
      />
      <Route
        path="*"
        element={
          <DashboardLayout>
            <NotFound />
          </DashboardLayout>
        }
      />
    </Routes>
  );
}

function returnMainPath(isLogin, currentUser) {
  let route;
  if (isLogin && currentUser?.isOnboarding) {
    route = <Navigate to="pick-user" />;
  } else if (isLogin) {
    route = <Navigate to="dashboard/app" />;
  } else {
    route = <Navigate to="login" />;
  }
  return route;
}

export default function Router() {
  const location = useLocation();
  const currentUser = useSelector((state) => state.auth.currentUser);
  const loading = useSelector((state) => state.auth.loading);
  const isLogin = useSelector((state) => state.auth.isLogin);
  const loggedInAs = useSelector((state) => state.auth.loggedInAs);

  if (!loading) {
    // This router checking condition is there because when user is logged in
    // Then after because of this loggedInAs flag user show dashboard but current url /login and use saw 404 page
    // It will change after login response successfully get so avoiding this kind of UI interaction
    // This condition helps when our URL is changes then only we deal with another routes display.
    if (
      currentUser?.isOnboarding === false &&
      loggedInAs === 'teacher' &&
      location.pathname !== '/login'
    ) {
      return <TeacherRoutes />;
    }
    if (
      currentUser?.isOnboarding === false &&
      loggedInAs === 'student' &&
      location.pathname !== '/login'
    ) {
      return <StudentRoutes />;
    }
    if (
      currentUser?.isOnboarding === false &&
      loggedInAs === 'admin' &&
      location.pathname !== '/login'
    ) {
      return <AdminRoutes />;
    }
    return (
      <Routes>
        <Route path="/" element={returnMainPath(isLogin, currentUser)} />
        <Route path="enroll/:id" element={<EnrollPage />} />
        <Route path="enroll/isJoinClass=abcd" element={<EnrollPage />} />
        <Route
          path="login"
          element={
            <AuthProvider>
              <Login />
            </AuthProvider>
          }
        />
        <Route
          path="register"
          element={
            <AuthProvider>
              <Register />
            </AuthProvider>
          }
        />
        <Route
          path="forgetPassword"
          element={
            <AuthProvider>
              <ForgetPassword />
            </AuthProvider>
          }
        />
        {/* == Pick User Type Route == */}
        <Route path="pick-user" element={<PickUserType />} />
        {/* <Route path="instituteRegistration" element={<Registration />} /> */}
        <Route path="*" element={!isLogin && !currentUser && <NotFound />} />
      </Routes>
    );
  }
  return null;
}
